var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 60,
    viewBox: "0 0 47 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6927 53.4928L21.7158 47.5159L18.4619 50.7698L27.6927 60.0005L46.1542 41.539L42.9004 38.2852L27.6927 53.4928Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61538 55.3846V13.8462H32.3077V34.6154H36.9231V4.61538C36.9219 3.39168 36.4352 2.21845 35.5699 1.35316C34.7046 0.487877 33.5314 0.00122187 32.3077 0H4.61538C3.39168 0.00122187 2.21845 0.487877 1.35316 1.35316C0.487877 2.21845 0.00122187 3.39168 0 4.61538V55.3846C0.00122187 56.6083 0.487877 57.7815 1.35316 58.6468C2.21845 59.5121 3.39168 59.9988 4.61538 60H13.8462V55.3846H4.61538ZM4.61538 4.61538H32.3077V9.23077H4.61538V4.61538Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService6);
export default __webpack_public_path__ + "static/media/service6.94330168fda6d2619686984e9c8fd46a.svg";
export { ForwardRef as ReactComponent };